import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getProperties = () => {
  return axios.get(`${process.env.API_URL}/properties?populate=*`)
}



/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getLocations = () => {
  return axios.get(`${process.env.API_URL}/locations?fields[0]=name`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getPropertyTypes = () => {
  return axios.get(`${process.env.API_URL}/property-types?fields[0]=name`)
}

export const getPropertiesChange = (location, type, valueIRR, valueCoC) => {
  let filterLocation = '', filterType = '', filterIRR = '', filterCoC = ''
  if (location > 0)
    filterLocation = `&filters[location][id][$eq]=${location}`

  if (type > 0)
    filterType = `&filters[property_type][id][$eq]=${type}`

  if(valueIRR > 0)
    filterIRR = `&filters[IRR][$lte]=${valueIRR}`  

  if(valueCoC > 0)
    filterCoC = `&filters[CoC][$lte]=${valueCoC}`  

  return axios.get(`${process.env.API_URL}/properties?populate=*${filterLocation}${filterType}${filterIRR}${filterCoC}`)
}